import {B26} from "../outputs/internal/B26";
import {B6} from "../outputs/internal/B6";
import {B14} from "../outputs/internal/B14";
import {XS4} from "../outputs/internal/XS4";
import {XS5} from "../outputs/internal/XS5";
import {B40} from "../outputs/internal/B40";
import {B5} from "../outputs/internal/B5";
import {B7} from "../outputs/internal/B7";
import {B16} from "../outputs/internal/B16";
import {B18} from "../outputs/internal/B18";
import {B30} from "../outputs/internal/B30";
import {B4} from "../outputs/internal/B4";
import {B21} from "../outputs/internal/B21";
import {B9} from "../outputs/internal/B9";
import {B10} from "../outputs/internal/B10";
import {B11} from "../outputs/internal/B11";
import {B12} from "../outputs/internal/B12";
import {B15} from "../outputs/internal/B15";
import {B22} from "../outputs/internal/B22";
import {B31} from "../outputs/internal/B31";
import {FL1} from "../outputs/internal/FL1";
import {B24} from "../outputs/internal/B24";
import {B29} from "../outputs/internal/B29";
import {B38} from "../outputs/internal/B38";
import {FL5} from "../outputs/internal/FL5";
import {B1} from "../outputs/internal/B1";
import {B2} from "../outputs/internal/B2";
import {B3} from "../outputs/internal/B3";
import {B25} from "../outputs/internal/B25";
import {B13} from "../outputs/internal/B13";
import {B17} from "../outputs/internal/B17";
import {B20} from "../outputs/internal/B20";
import {B27} from "../outputs/internal/B27";
import {B28} from "../outputs/internal/B28";
import {OP5} from "../outputs/internal/OP5";
import {G1} from "../outputs/internal/G1";
import {G2} from "../outputs/internal/G2";
import {G6} from "../outputs/internal/G6";
import {G7} from "../outputs/internal/G7";
import {C1} from "../outputs/compare/C1";
import {C2} from "../outputs/compare/C2";
import {C19} from "../outputs/compare/C19";
import {C20} from "../outputs/compare/C20";
import {C13} from "../outputs/compare/C13";
import {C21} from "../outputs/compare/C21";
import {C3} from "../outputs/compare/C3";
import {C4} from "../outputs/compare/C4";
import {C5} from "../outputs/compare/C5";
import {C6} from "../outputs/compare/C6";
import {C12} from "../outputs/compare/C12";
import {C8} from "../outputs/compare/C8";
import {C9} from "../outputs/compare/C9";
import {C10} from "../outputs/compare/C10";
import {C7} from "../outputs/compare/C7";
import {C11} from "../outputs/compare/C11";
import {StaElevPlotLayer} from "../outputs/ui/StationElevationPlot";
import {PlanProfiles} from "../ProjectUploader";
import CrossSectionWindow from "../outputs/ui/CrossSection/CrossSectionWindow";
import DeckRoadwayWindow from "../outputs/ui/DeckRoadway/DeckRoadwayWindow";
import BridgeWindow from "../outputs/ui/Bridge/BridgeWindow";
import CulvertWindow from "../outputs/ui/Culvert/CulvertWindow";
import ExpContUI from "../outputs/ui/ExpContUI";
import {COP2} from "../outputs/compare/C-OP2";
import SV1 from "../outputs/internal/SV1";
import SV2 from "../outputs/internal/SV2";
import SV3 from "../outputs/internal/SV3";
import SV4 from "../outputs/internal/SV4";
import SV5 from "../outputs/internal/SV5";
import SV6 from "../outputs/internal/SV6";
import SV7 from "../outputs/internal/SV7";
import {XY8} from "../outputs/internal/XY8";

const CheckOperations = [
    {
        title: 'Cross Section',
        children: [
            {
                title: 'DS Reach Length/River Station',
                key: 'B6',
                key_text: 'XS1',
                request: 'check_reach_length',
                ui: {
                    Component: B6,
                    UI: {
                        Component: (rs) => {
                            return (
                                <CrossSectionWindow
                                    riverStation={rs}
                                />
                            )
                        }
                    }
                }
            },
            {
                title: 'Thalweg within Bank Stations',
                key: 'B14',
                key_text: 'XS2',
                request: 'check_lowest_station',
                ui: {
                    Component: B14,
                    Plot: {
                        Type: 'CrossSection',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_base)]
                        },
                        onChangeRS: (rs) => {
                            return [
                                StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.B_THALWEG,
                                StaElevPlotLayer.StaElevLayerNames.B_BANKS,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR100,
                                StaElevPlotLayer.StaElevLayerNames.B_BLOCK_OBST,
                            ]
                        }
                    }
                }
            },
            {
                title: 'Cross Section Spacing',
                key: 'B26',
                key_text: 'XS3',
                request: 'cross_section_spacing',
                ui: {
                    Component: B26
                }
            },
            {
                title: 'Bank Station Elevation',
                key: 'XS4',
                key_text: 'XS4',
                request: 'check_bank_sta_elev',
                ui: {
                    Component: XS4,
                    Plot: {
                        Type: 'CrossSection',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_base)]
                        },
                        onChangeRS: (rs) => {
                            return [
                                StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.B_THALWEG,
                                StaElevPlotLayer.StaElevLayerNames.B_BANKS,
                            ]
                        }
                    }
                }
            },
            {
                title: 'Reach Invert Profile',
                key: 'XS5',
                key_text: 'XS5',
                request: 'check_invert_slope',
                ui: {
                    Component: XS5
                }
            },
        ]
    },
    {
        title: 'Structure',
        children: [
            {
                type: 'structure',
                title: 'Structure Geometry',
                key: 'B40',
                key_text: 'ST1',
                request: 'check_bridge_info',
                ui: {
                    Component: B40,
                    Plot: {
                        Type: 'Structure',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_us_base), ...StaElevPlotLayer.getLayersFromData('B', rs?.plot_ds_base)]
                        },
                        onChangeRS: (rs) => {
                            return [
                                StaElevPlotLayer.StructureLayouts.B_STA_ELEV,
                                StaElevPlotLayer.StructureLayouts.B_BANKS,
                                StaElevPlotLayer.StructureLayouts.B_LOW_CHORDS,
                                StaElevPlotLayer.StructureLayouts.B_HIGH_CHORDS,
                                StaElevPlotLayer.StructureLayouts.B_XS_INEFF,
                                StaElevPlotLayer.StructureLayouts.B_WSEL_YR100,
                            ]
                        }
                    }
                }
            },
            {
                type: 'structure',
                title: 'Cont/Exp Ratio around Structure',
                key: 'B5',
                key_text: 'ST2',
                request: 'check_cont_exp_structure',
                ui: {
                    Component: B5,
                    Plot: {
                        Type: 'Structure',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_us_base), ...StaElevPlotLayer.getLayersFromData('B', rs?.plot_ds_base)]
                        },
                        onChangeRS: (rs) => {
                            return [
                                StaElevPlotLayer.StructureLayouts.B_STA_ELEV,
                                StaElevPlotLayer.StructureLayouts.B_BANKS,
                                StaElevPlotLayer.StructureLayouts.B_LOW_CHORDS,
                                StaElevPlotLayer.StructureLayouts.B_HIGH_CHORDS,
                                StaElevPlotLayer.StructureLayouts.B_XS_INEFF,
                                StaElevPlotLayer.StructureLayouts.B_WSEL_YR100,
                            ]
                        }
                    }
                }
            },
            {
                type: 'structure',
                title: 'Structure Modeling Method',
                key: 'B7',
                key_text: 'ST3',
                request: 'check_bridge_modelling_method',
                ui: {
                    Component: B7,
                    Plot: {
                        Type: 'Structure',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_us_base), ...StaElevPlotLayer.getLayersFromData('B', rs?.plot_ds_base)]
                        },
                        onChangeRS: (rs) => {
                            return [
                                StaElevPlotLayer.StructureLayouts.B_STA_ELEV,
                                StaElevPlotLayer.StructureLayouts.B_BANKS,
                                StaElevPlotLayer.StructureLayouts.B_LOW_CHORDS,
                                StaElevPlotLayer.StructureLayouts.B_HIGH_CHORDS,
                                StaElevPlotLayer.StructureLayouts.B_XS_INEFF,
                                StaElevPlotLayer.StructureLayouts.B_WSEL_YR100,
                            ]
                        }
                    },
                    UI: {
                        Component: (rs) => {
                            return (
                                <>
                                    <DeckRoadwayWindow
                                        riverStation={rs}
                                    />
                                    <br/>
                                    <BridgeWindow
                                        riverStation={rs}
                                    />
                                </>
                            )
                        }
                    }
                }
            },
            {
                type: 'structure',
                title: 'Structure Fits',
                key: 'B16',
                key_text: 'ST4',
                request: 'check_bridge_culvert_fits',
                ui: {
                    Component: B16
                }
            },
            {
                type: 'structure',
                title: 'XS around Structure',
                key: 'B18',
                key_text: 'ST5',
                request: 'check_xs_around_structure',
                ui: {
                    Component: B18
                }
            },
            {
                type: 'structure',
                title: 'Ineffective Area around Structure',
                key: 'B30',
                key_text: 'ST6',
                request: 'check_structure_overflow',
                ui: {
                    Component: B30,
                    Plot: {
                        Type: 'Structure',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_us_base), ...StaElevPlotLayer.getLayersFromData('B', rs?.plot_ds_base)]
                        },
                        onChangeRS: (rs) => {
                            const wsels = []

                            rs?.profiles?.forEach(x => {
                                const p = PlanProfiles.find(y => y.label === x)
                                if(p)
                                    wsels.push(`B: WSEL ${p.value}`)
                                else
                                    wsels.push(`B: WSEL ${x}`)
                            })

                            return [
                                StaElevPlotLayer.StaElevLayerNames.B_WEIR_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.B_BANKS,
                                StaElevPlotLayer.StaElevLayerNames.B_BLOCK_OBST,
                                StaElevPlotLayer.StaElevLayerNames.B_XS_INEFF,
                                ...wsels
                            ]
                        }
                    }
                }
            },
        ]
    },
    {
        title: 'R/T Coefficient',
        children: [
            {
                title: 'Contraction/Expansion Coefficient',
                key: 'B4',
                key_text: 'RT1',
                request: 'check_cont_exp_coeff',
                ui: {
                    Component: B4,
                    UI: {
                        Component: (rs) => {
                            return (
                                <>
                                    <ExpContUI riverStation={rs} />
                                    <br/>
                                    <CrossSectionWindow
                                        riverStation={rs}
                                    />
                                </>
                            )
                        }
                    }
                }
            },
            {
                title: 'Manning\'s n',
                key: 'B21',
                key_text: 'RT2',
                request: 'check_manningsn',
                ui: {
                    Component: B21,
                    Plot: {
                        Type: 'CrossSection',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_base)]
                        },
                        onChangeRS: (rs) => {
                            return [
                                StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.B_XS_INEFF,
                                StaElevPlotLayer.StaElevLayerNames.B_BANKS,
                                StaElevPlotLayer.StaElevLayerNames.B_MANN,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR100,
                                StaElevPlotLayer.StaElevLayerNames.B_BLOCK_OBST,
                            ]
                        }
                    },
                    UI: {
                        Component: (rs) => {
                            return (
                                <CrossSectionWindow
                                    riverStation={rs}
                                />
                            )
                        }
                    }
                }
            },
        ]
    },
    {
        title: 'Schematic',
        children: [
            {
                type: 'schematic',
                title: 'Geo Referencing',
                key: 'B9',
                key_text: 'XY1',
                request: 'check_geo_referencing',
                ui: {
                    Component: B9
                }
            },
            {
                type: 'schematic',
                title: 'Bank Station',
                key: 'B10',
                key_text: 'XY2',
                request: 'check_bank_station',
                ui: {
                    Component: B10
                }
            },
            {
                type: 'schematic',
                title: 'Ratio of Cutline to XS Length',
                key: 'B11',
                key_text: 'XY3',
                request: 'check_ratio_of_cutline_xs',
                ui: {
                    Component: B11
                }
            },
            {
                type: 'schematic',
                title: 'Skew Angle',
                key: 'B12',
                key_text: 'XY4',
                request: 'check_skew_angle',
                ui: {
                    Component: B12
                }
            },
            {
                type: 'schematic',
                title: 'Intersecting Cross sections',
                key: 'B15',
                key_text: 'XY5',
                request: 'check_intersecting_cs',
                ui: {
                    Component: B15
                }
            },
            {
                type: 'schematic',
                title: 'Schematic Channel DS Reach Length',
                key: 'B22',
                key_text: 'XY6',
                request: 'check_schematic_channel_dsrl',
                ui: {
                    Component: B22
                }
            },
            {
                type: 'schematic',
                title: 'Schematic RS',
                key: 'B31',
                key_text: 'XY7',
                request: 'check_schematic_rs',
                ui: {
                    Component: B31
                }
            },
            {
                type: 'schematic',
                title: 'Schematic Overbank DS Reach Length',
                key: 'XY8',
                key_text: 'XY8',
                request: 'schematic_channel_dsrl_flow_paths',
                ui: {
                    Component: XY8
                }
            },
        ]
    },
    {
        title: 'Flow',
        children: [
            {
                title: 'Flow Change Rate',
                key: 'FL1',
                key_text: 'FL1',
                request: 'check_flow_change_rate',
                ui: {
                    Component: FL1
                }
            },
            {
                title: 'Flow Change Direction',
                key: 'B24',
                key_text: 'FL2',
                request: 'check_flow_decreases',
                ui: {
                    Component: B24
                }
            },
            {
                title: 'Flow US/DS of Structure',
                key: 'B29',
                key_text: 'FL3',
                request: 'check_flow_usds_structure',
                ui: {
                    Component: B29
                }
            },
            {
                title: 'Set internal Changes in WSEL',
                key: 'B38',
                key_text: 'FL4',
                request: 'check_set_internal_change',
                ui: {
                    Component: B38
                }
            },
            {
                title: 'Normal Depth Boundary Condition',
                key: 'FL5',
                key_text: 'FL5',
                request: 'check_normal_depth_boundary',
                ui: {
                    Component: FL5
                }
            },
        ]
    },
    {
        title: 'Floodway',
        children: [
            {
                type: 'floadway',
                title: 'Surcharge',
                key: 'B1',
                key_text: 'FW1',
                request: 'check_surcharge',
                ui: {
                    Component: B1,
                    Plot: {
                        Type: 'CrossSection',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_base)]
                        },
                        onChangeRS: (rs) => {
                            return [
                                StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.B_BANKS,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR100,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_FW,
                                StaElevPlotLayer.StaElevLayerNames.B_ENCR,
                                StaElevPlotLayer.StaElevLayerNames.B_XS_INEFF,
                            ]
                        }
                    }
                }
            },
            {
                type: 'floadway',
                title: 'Encroachment Station Placement',
                key: 'B2',
                key_text: 'FW2',
                request: 'check_enc_station_placement',
                ui: {
                    Component: B2,
                    Plot: {
                        Type: 'CrossSection',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_base)]
                        },
                        onChangeRS: (rs) => {
                            return [
                                StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.B_BANKS,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_FW,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR100,
                                StaElevPlotLayer.StaElevLayerNames.B_ENCR,
                                StaElevPlotLayer.StaElevLayerNames.B_XS_INEFF,
                            ]
                        }
                    }
                }
            },
            {
                type: 'floadway',
                title: 'Encroachment Method',
                key: 'B3',
                key_text: 'FW3',
                request: 'check_enc_method',
                ui: {
                    Component: B3
                }
            },
            {
                type: 'floadway',
                title: 'Encroachment River Station',
                key: 'B25',
                key_text: 'FW4',
                request: 'check_encr_river_station',
                ui: {
                    Component: B25
                }
            },
            {
                type: 'floadway',
                title: 'FW – 100yr Flow Data Consistency',
                key: 'B13',
                key_text: 'FW5',
                request: 'check_flow_data',
                ui: {
                    Component: B13
                }
            },
        ]
    },
    {
        title: 'Outputs',
        children: [
            {
                type: 'output',
                title: 'Flow Contained within XS',
                key: 'B17',
                key_text: 'OP1',
                request: 'check_flow_contained',
                ui: {
                    Component: B17,
                    Plot: {
                        Type: 'CrossSection',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_base)]
                        },
                        onChangeRS: (rs) => {
                            const wsels = []
                            wsels.push(`B: WSEL ${rs?.profile}`)

                            return [
                                StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.B_BANKS,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR2,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR10,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR25,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR50,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR100,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR500,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_FUTULT,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_FUT10,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_FUT20,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_FUT35,
                                StaElevPlotLayer.StaElevLayerNames.B_BLOCK_OBST,
                                ...wsels
                            ]
                        }
                    }
                }
            },
            {
                type: 'output',
                title: 'XS Low Elevation',
                key: 'B20',
                key_text: 'OP2',
                request: 'check_flow_contained_2',
                ui: {
                    Component: B20,
                    Plot: {
                        Type: 'CrossSection',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_base)]
                        },
                        onChangeRS: (rs) => {
                            return [
                                StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.B_BANKS,
                                StaElevPlotLayer.StaElevLayerNames.B_BLOCK_OBST,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_FW,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR2,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR10,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR25,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR50,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR100,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR500,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_FUTULT,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_FUT10,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_FUT20,
                                StaElevPlotLayer.StaElevLayerNames.B_WSEL_FUT35,
                            ]
                        }
                    }
                }
            },
            {
                type: 'output',
                title: 'Crossing WSEL profiles',
                key: 'B27',
                key_text: 'OP3',
                request: 'check_crossing_wsel',
                ui: {
                    Component: B27,
                    Plot: {
                        Type: 'CrossSection',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_base)]
                        },
                        onChangeRS: (rs) => {
                            const wsels = []

                            rs?.rs?.profiles?.forEach(x => {
                                const p = PlanProfiles.find(y => y.label === x.profile) || {value: x.profile}
                                wsels.push(`B: WSEL ${p.value}`)
                                const prev_p = PlanProfiles.find(y => y.label === x.prev_profile) || {value: x.prev_profile}
                                wsels.push(`B: WSEL ${prev_p.value}`)

                            })

                            return [
                                StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.B_BANKS,
                                ...wsels
                            ]
                        }
                    }
                }
            },
            {
                type: 'output',
                title: 'Choking WSEL profiles',
                key: 'B28',
                key_text: 'OP4',
                request: 'check_chocking_wsel',
                ui: {
                    Component: B28
                }
            },
            {
                type: 'output',
                title: 'Critical Depth',
                key: 'OP5',
                key_text: 'OP5',
                request: 'check_critical_depth',
                ui: {
                    Component: OP5
                }
            },
        ]
    },
    {
        title: 'WSEL Library',
        children: [
            {
                type: 'library',
                title: 'Library Model Info',
                key: 'G1',
                key_text: 'LB1',
                request: 'check_gage_rs_tnm',
                ui: {
                    Component: G1
                }
            },
            {
                type: 'library',
                title: 'Calculated WSEL table',
                key: 'G2',
                key_text: 'LB2',
                request: 'check_library_pivot_table',
                ui: {
                    Component: G2
                }
            },
            {
                type: 'library',
                title: 'Processed WSEL table',
                key: 'G6',
                key_text: 'LB3',
                request: 'check_library_pivot_table_interpolation',
                ui: {
                    Component: G6
                }
            },
            {
                type: 'library',
                title: 'Structure Inundation table',
                key: 'G7',
                key_text: 'LB4',
                request: 'check_library_report_structure',
                ui: {
                    Component: G7,
                    Plot: {
                        Type: 'Structure',
                        hideDS: true,
                        locWselEnable: true,
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_us_base)]
                        },
                        onChangeRS: (rs) => {
                            const wsels = []

                            wsels.push(`B: WSEL ${rs?.warning_item?.profile}`)
                            wsels.push(`B: WSEL ${rs?.weir_pressure_item?.profile}`)

                            return [
                                StaElevPlotLayer.StructureLayouts.B_STA_ELEV,
                                StaElevPlotLayer.StructureLayouts.B_BANKS,
                                StaElevPlotLayer.StructureLayouts.B_LOW_CHORDS,
                                StaElevPlotLayer.StructureLayouts.B_HIGH_CHORDS,
                                StaElevPlotLayer.StructureLayouts.B_LOW_LOW_CHORDS,
                                StaElevPlotLayer.StructureLayouts.B_LOW_HIGH_CHORDS,
                                ...wsels
                            ]
                        },
                    }
                }
            },
        ]
    },
    {
        title: 'Survey Data',
        children: [
            {
                type: 'survey',
                title: 'Culvert Invert Elevation',
                key: 'SV1',
                key_text: 'SV1',
                request: 'check_survey_data_cul_inv',
                ui: {
                    Component: SV1
                }
            },
            {
                type: 'survey',
                title: 'Bridge Low Chord Elevation',
                key: 'SV2',
                key_text: 'SV2',
                request: 'check_survey_data_bridge_low_chord',
                ui: {
                    Component: SV2
                }
            },
            {
                type: 'survey',
                title: 'Top of Bank Elevation',
                key: 'SV3',
                key_text: 'SV3',
                request: 'check_survey_data_top_of_bank',
                ui: {
                    Component: SV3
                }
            },
            {
                type: 'survey',
                title: 'Culvert Rise',
                key: 'SV4',
                key_text: 'SV4',
                request: 'check_survey_data_cul_rise',
                ui: {
                    Component: SV4
                }
            },
            {
                type: 'survey',
                title: 'Culvert Length',
                key: 'SV5',
                key_text: 'SV5',
                request: 'check_survey_data_cul_len',
                ui: {
                    Component: SV5
                }
            },
            {
                type: 'survey',
                title: 'Bridge Width',
                key: 'SV6',
                key_text: 'SV6',
                request: 'check_survey_data_bridge_width',
                ui: {
                    Component: SV6
                }
            },
            {
                type: 'survey',
                title: 'Stream TOBL/TOBR Survey Points',
                key: 'SV7',
                key_text: 'SV7',
                request: 'check_survey_stream_tobl_tobr',
                ui: {
                    Component: SV7
                }
            },
        ]
    }
]

const ComparisonOperations = [
    {
        title: 'Cross Section',
        children: [
            {
                title: 'Add/Remove XS',
                key: 'C1',
                key_text: 'C-XS1',
                request: 'compare_add_rem_cross_section',
                ui: {
                    Component: C1
                }
            },
            {
                title: 'XS Station/Elevation',
                key: 'C2',
                key_text: 'C-XS2',
                request: 'compare_cross_section_sta_elev',
                ui: {
                    Component: C2,
                    Plot: {
                        Type: 'CrossSection',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_base), ...StaElevPlotLayer.getLayersFromData('C', rs?.plot_cmp)]
                        },
                        onChangeRS: (rs) => {
                            return [
                                StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.C_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.C_WSEL_YR100,
                            ]
                        }
                    },
                    UI: {
                        Component: (rs) => {
                            return (
                                <CrossSectionWindow
                                    riverStation={rs}
                                />
                            )
                        }
                    }
                }
            },
            {
                title: 'Adjustment cross-section stations',
                key: 'C19',
                key_text: 'C-XS2',
                request: 'compare_sta_elev_adj',
                ui: {
                    Component: C19,
                    UI: {
                        Component: (rs) => {
                            return (
                                <CrossSectionWindow
                                    riverStation={rs}
                                />
                            )
                        }
                    }
                }
            },
            {
                title: 'DS Reach Length',
                key: 'C20',
                key_text: 'C-XS3',
                request: 'compare_ds_reach_length',
                ui: {
                    Component: C20,
                    UI: {
                        Component: (rs) => {
                            return (
                                <CrossSectionWindow
                                    riverStation={rs}
                                />
                            )
                        }
                    }
                }
            },
            {
                title: 'Ineffective Area',
                key: 'C13',
                key_text: 'C-XS4',
                request: 'compare_ieff_area',
                ui: {
                    Component: C13,
                    Plot: {
                        Type: 'CrossSection',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_base), ...StaElevPlotLayer.getLayersFromData('C', rs?.plot_cmp)]
                        },
                        onChangeRS: (rs) => {
                            return [
                                StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.C_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.C_XS_INEFF,
                                StaElevPlotLayer.StaElevLayerNames.B_XS_INEFF,
                                StaElevPlotLayer.StaElevLayerNames.C_WSEL_YR100,
                            ]
                        }
                    },
                    UI: {
                        Component: (rs) => {
                            return (
                                <CrossSectionWindow
                                    riverStation={rs}
                                />
                            )
                        }
                    }
                }
            },
            {
                title: 'Obstructed Areas',
                key: 'C21',
                key_text: 'C-XS5',
                request: 'compare_obstructed_area',
                ui: {
                    Component: C21,
                    Plot: {
                        Type: 'CrossSection',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_base), ...StaElevPlotLayer.getLayersFromData('C', rs?.plot_cmp)]
                        },
                        onChangeRS: (rs) => {
                            return [
                                StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.C_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.C_BLOCK_OBST,
                                StaElevPlotLayer.StaElevLayerNames.B_BLOCK_OBST,
                                StaElevPlotLayer.StaElevLayerNames.C_WSEL_YR100,
                            ]
                        }
                    }
                }
            },
        ]
    },
    {
        title: 'Structure',
        children: [
            {
                title: 'Add/Remove Structure',
                key: 'C3',
                key_text: 'C-ST1',
                request: 'compare_add_rem_structure',
                ui: {
                    Component: C3
                }
            },
            {
                title: 'Structure Geometry',
                key: 'C4',
                key_text: 'C-ST2',
                request: 'compare_structure_geo',
                ui: {
                    Component: C4,
                    Plot: {
                        Type: 'Structure',
                        onPlotLayers: (rs) => {
                            return [
                                ...StaElevPlotLayer.getLayersFromData('B', rs?.plot_us_base),
                                ...StaElevPlotLayer.getLayersFromData('B', rs?.plot_ds_base),
                                ...StaElevPlotLayer.getLayersFromData('C', rs?.plot_us_cmp),
                                ...StaElevPlotLayer.getLayersFromData('C', rs?.plot_ds_cmp),
                            ]
                        },
                        onChangeRS: (rs) => {
                            return [
                                StaElevPlotLayer.StructureLayouts.B_STA_ELEV,
                                StaElevPlotLayer.StructureLayouts.B_BANKS,
                                StaElevPlotLayer.StructureLayouts.B_LOW_CHORDS,
                                StaElevPlotLayer.StructureLayouts.B_HIGH_CHORDS,
                                StaElevPlotLayer.StructureLayouts.C_STA_ELEV,
                                StaElevPlotLayer.StructureLayouts.C_BANKS,
                                StaElevPlotLayer.StructureLayouts.C_LOW_CHORDS,
                                StaElevPlotLayer.StructureLayouts.C_HIGH_CHORDS,
                            ]
                        }
                    },
                    UI: {
                        Component: (rs) => {
                            return (
                                <>
                                    <DeckRoadwayWindow
                                        riverStation={rs}
                                    />
                                    {
                                        rs?.type === 'Culvert' && (
                                            <>
                                                <br/>
                                                <CulvertWindow
                                                    riverStation={rs}
                                                />
                                            </>
                                        )
                                    }
                                    {
                                        rs?.type === 'Bridge' && (
                                            <>
                                                <br/>
                                                <BridgeWindow
                                                    riverStation={rs}
                                                />
                                            </>
                                        )
                                    }
                                </>
                            )
                        }
                    }
                }
            },

            {
                title: 'Bridge Modeling Approach',
                key: 'C5',
                key_text: 'C-ST3',
                request: 'compare_bridge_modelling_method',
                ui: {
                    Component: C5,
                    UI: {
                        Component: (rs) => {
                            return (
                                <BridgeWindow
                                    riverStation={rs}
                                />
                            )
                        }
                    }
                }
            },
        ]
    },
    {
        title: "R/T Coefficient",
        children: [
            {
                title: "Manning's n",
                key: 'C6',
                key_text: 'C-RT1',
                request: 'compare_mannings',
                ui: {
                    Component: C6,
                    UI: {
                        Component: (rs) => {
                            return (
                                <CrossSectionWindow
                                    riverStation={rs}
                                />
                            )
                        }
                    }
                }
            },
            {
                title: 'Contraction/Expansion Coefficient',
                key: 'C12',
                key_text: 'C-RT2',
                request: 'compare_exp_cont',
                ui: {
                    Component: C12,
                    UI: {
                        Component: (rs) => {
                            return (
                                <CrossSectionWindow
                                    riverStation={rs}
                                />
                            )
                        }
                    }
                }
            },
        ]
    },
    {
        title: 'Schematic',
        children: [
            {
                type: 'schematic',
                title: 'XS Cutlines Geo-Reference',
                key: 'C8',
                key_text: 'C-XY1',
                request: 'compare_xs_cutlines_geo_ref',
                ui: {
                    Component: C8
                }
            },
            {
                type: 'schematic',
                title: 'Reach Invert Line Geo-Reference',
                key: 'C9',
                key_text: 'C-XY2',
                request: 'compare_reach_invert_line',
                ui: {
                    Component: C9
                }
            },
        ]
    },
    {
        title: 'Flow',
        children: [
            {
                title: 'Flow Data',
                key: 'C10',
                key_text: 'C-FL1',
                request: 'compare_flow_data',
                ui: {
                    Component: C10
                }
            },
        ]
    },
    {
        title: 'Floodway',
        children: [
            {
                title: 'Encroachment Station',
                key: 'C7',
                key_text: 'C-FW1',
                request: 'compare_enc_station',
                ui: {
                    Component: C7,
                    Plot: {
                        Type: 'CrossSection',
                        onPlotLayers: (rs) => {
                            return [...StaElevPlotLayer.getLayersFromData('B', rs?.plot_base), ...StaElevPlotLayer.getLayersFromData('C', rs?.plot_cmp)]
                        },
                        onChangeRS: (rs) => {
                            return [
                                StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.C_STA_ELEV,
                                StaElevPlotLayer.StaElevLayerNames.C_ENCR,
                                StaElevPlotLayer.StaElevLayerNames.B_ENCR,
                                StaElevPlotLayer.StaElevLayerNames.C_WSEL_YR100,
                                StaElevPlotLayer.StaElevLayerNames.C_WSEL_FW,
                            ]
                        }
                    }
                }
            },
        ]
    },
    {
        title: 'Outputs',
        children: [
            {
                type: 'yr100',
                title: '100yr WSEL',
                key: 'C11',
                key_text: 'C-OP1',
                request: 'compare_output_wsel',
                ui: {
                    Component: C11
                }
            },
            {
                type: 'floadway',
                title: 'FW WSEL',
                key: 'C-OP2',
                key_text: 'C-OP2',
                request: 'compare_output_fw_wsel',
                ui: {
                    Component: COP2
                }
            },
        ]
    },
]

export {CheckOperations, ComparisonOperations}